import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import App from "./App";
import Auth from "j-toker";
import iNoBounce from "inobounce";
import PushedView from "./pages/pushed_view";
import { isMobile } from "react-device-detect";
import ErrorPage from "./pages/404";
import PresentationView from "./pages/presentation";
import UpdatePasswordView from "./pages/update_password";
import TermsView from "./pages/terms";
class RouterHandler extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: Auth.user
    };
  }

  componentWillMount() {
    if (isMobile) {
      require("./design/style_mobile.css");
    }
  }

  componentDidMount() {
    //iNoBounce.enable();
  }

  render() {
    return (
      <Router>
        <Switch>
          {/* <Route path="/sign_in" component={PushedView} />
          <Route path="/sign_up" component={PushedView} />
          <Route path="/forget_password" component={PushedView} />
          <Route path="/create" component={PushedView} />
          <Route path="/search" component={PushedView} /> */}
          {/* <Route path="/question/:id" component={PushedView} />
          <Route path="/users/:id" component={PushedView} />
          <Route path="/category/:id" component={PushedView} />
          <Route path="/recommendations/:id" component={PushedView} />
          <Route path="/hashtag/:id" component={PushedView} />
          <Route path="/invite/:id" component={PushedView} />
          <Route path="/list/:id" component={PushedView} />
          <Route path="/profile/bookmarks" component={PushedView} /> */}
          {/* <Route path="*" component={App} /> */}
          <Route path="/update_password" component={UpdatePasswordView} />
          <Route path="/terms" component={TermsView} />
          <Route path="*" component={PresentationView} />
        </Switch>
      </Router>
    );
  }
}

export default RouterHandler;

// configure jToker
Auth.configure({
  apiUrl: "https://app.yaystack.co/api/v1/",
  emailSignInPath: "auth/sign_in",
  emailRegistrationPath: "auth",
  tokenValidationPath: "auth/validate_token",
  signOutPath: "auth/sign_out",
  passwordResetPath: "auth/password",
  passwordUpdatePath: "auth/password"
});



// WEBPACK FOOTER //
// ./src/routerHandler.jsx